:host {
  --gradient-angle-0: 0deg;
  --gradient-angle-90: 90deg;
  --gradient-angle-180: 180deg;
  --gradient-angle-270: 270deg;
  --gradient-stops:
    #262626 0%, rgba(38, 38, 38, 0.5) 35%, rgba(38, 38, 38, 0) 70%;
}

.wrapper {
  width: 100%;
  height: 100%;
  perspective: 1000px;
  color: white;
  cursor: pointer;
}

.card {
  width: 100%;
  height: 100%;
  position: relative;
  transform-style: preserve-3d;
  transition: transform 0.6s;
}

.card.flipped {
  transform: rotateY(180deg);
}

.frontside,
.backside {
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden; /* Safari support */
  border-radius: 16px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.frontside {
  display: flex;
  background-color: white;
  z-index: 2;

  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.frontside-gradient {
  padding: 16px;
  border-radius: 16px;
  height: 100%;
  background: linear-gradient(var(--gradient-angle-180), var(--gradient-stops));
}

.frontside-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;

  h2,
  h3 {
    margin: 0;
    text-align: center;
  }

  h2 {
    margin-top: 16px;
    margin-bottom: 8px;
    line-height: 40px;
    font-size: 32px;
    font-weight: 700;
    width: 212px;
  }

  h3 {
    margin-top: 8px;
    font-size: 20px;
    line-height: 24px;
    font-weight: 400;
  }

  &.align-text-bottom {
    justify-content: flex-end;
    align-items: center;
  }
}

.info-icon-button {
  position: absolute;
  right: 16px;
  bottom: 16px;
  color: inherit;
}

.gradient-direction {
  &-left {
    .frontside-gradient {
      background: linear-gradient(
        var(--gradient-angle-270),
        var(--gradient-stops)
      );
    }
  }
  &-top {
    .frontside-gradient {
      background: linear-gradient(
        var(--gradient-angle-0),
        var(--gradient-stops)
      );
    }
  }
  &-right {
    .frontside-gradient {
      background: linear-gradient(
        var(--gradient-angle-90),
        var(--gradient-stops)
      );
    }
  }
}

.backside {
  transform: rotateY(180deg);

  &-container {
    box-sizing: border-box;
    color: #000;
    padding: 24px;
  }

  h4 {
    margin: 0;
    margin-bottom: 16px;
    margin-top: 48px;
    font-size: 24px;
  }

  p {
    margin: 0;
    margin-bottom: 16px;
  }

  .unflip-button {
    position: absolute;
    top: 16px;
    right: 16px;
  }
}
